module.exports = __webpack_public_path__ + "img/information.301edf45.png";